import React, { memo } from 'react';
import { Textfit } from 'react-textfit';
import { useStorage } from '~Components/Storage';
import type { StorageData } from '~Components/Storage';

interface Props {
  text: string;
  color?: string;
}

const ARTICLE_TEXT_SIZE_RANGES: Record<
  StorageData['articleTextSize'],
  { min: number; max: number }
> = {
  standard: { min: 8, max: 12 },
  big: { min: 12, max: 14 },
  bigger: { min: 14, max: 18 },
};

const FitTitle: React.FC<Props> = ({ text, color }) => {
  const [storage] = useStorage();
  const { min, max } = ARTICLE_TEXT_SIZE_RANGES[storage.articleTextSize];

  return (
    <Textfit mode="multi" max={max} min={min} style={{ color }}>

      {text}
    </Textfit>
  );
};

export default memo(FitTitle);
